import { apiGet, apiPost } from "@softmax/observatory-client/client";
import { skipToken } from "@tanstack/react-query";

import type { ApiTransport } from "@softmax/observatory-client/transport";

import { limitPublicRead } from "@/data/api";

export const browserWatchApi = {
  get: <T>(path: string, opts?: { signal?: AbortSignal }): Promise<T> =>
    limitPublicRead(() =>
      apiGet<T>(path, { ...opts, elevatedPrivileges: false }),
    ),
  post: <T>(path: string, body?: unknown): Promise<T> =>
    limitPublicRead(() =>
      apiPost<T>(path, body, { elevatedPrivileges: false }),
    ),
} satisfies ApiTransport;

export function limitWatchQueryFn<TContext, TResult>(
  queryFn:
    | ((context: TContext) => TResult | Promise<TResult>)
    | typeof skipToken
    | undefined,
) {
  if (queryFn === undefined)
    throw new Error("Watch queries require a query function");

  return typeof queryFn === "function"
    ? (context: TContext) =>
        limitPublicRead(() => Promise.resolve(queryFn(context)))
    : queryFn;
}
